export interface EquipmentUnit {
  id: number;
  serialNumber: string;
  status: "available" | "assigned";
  assignment: string | null;
}

export interface Equipment {
  id: string;
  name: string;
  category: string;
  brand: string;
  model: string;
  serialNumber: string;
  quantity: number;
  totalQuantity: number;
  totalAssigned: number;
  remainingTotal: number;
  assignedSerialNumbers: string[];
  availableSerialNumbers: string[];
  units: EquipmentUnit[];
  type: "Studio Owned" | "Available for Rent" | "Available for Sale";
  price: number;
  status: "Available" | "Assigned" | "Under Service" | "Sold" | "Retired";
  purchaseDate: string;
  purchaseVendor: string;
  warrantyStart: string;
  warrantyExpiry: string;
  lastServiceDate: string;
  nextServiceDueDate: string;
  serviceNotes: string;
  assignedMember?: string;
  assignedMemberId?: string;
  assignmentDate?: string;
  expectedReturnDate?: string;
  branch_id?: number | null;
  branch_name?: string | null;
}

export const typeMap: Record<string, Equipment["type"]> = {
  studio_owned: "Studio Owned",
  rent: "Available for Rent",
  sale: "Available for Sale"
};

export const typeRevMap: Record<Equipment["type"], "studio_owned" | "rent" | "sale"> = {
  "Studio Owned": "studio_owned",
  "Available for Rent": "rent",
  "Available for Sale": "sale"
};

export const statusMap: Record<string, Equipment["status"]> = {
  available: "Available",
  assigned: "Assigned",
  under_service: "Under Service",
  sold: "Sold",
  retired: "Retired"
};

export const statusRevMap: Record<Equipment["status"], "available" | "assigned" | "under_service" | "sold" | "retired"> = {
  "Available": "available",
  "Assigned": "assigned",
  "Under Service": "under_service",
  "Sold": "sold",
  "Retired": "retired"
};

export const STATUSES: Equipment["status"][] = ["Available", "Assigned", "Under Service", "Sold", "Retired"];
